import { CreateUIAnalyticsEvent } from "@atlaskit/analytics-next";

import { isProduction } from "@/components/signup/utils";

export const createBaseUrl = (
    onDemandUrl: string | undefined,
    products: readonly string[],
    dataRegion: string | undefined,
    cloudId: string,
    _admin: boolean | undefined,
    createAnalyticsEvent: CreateUIAnalyticsEvent
): string => {
    if (!isValidOnDemandUrl(onDemandUrl || "")) {
        createAnalyticsEvent({
            action: "validateOnDemandUrl",
            actionSubject: "invalidUrlOnRedirect",
            eventComponent: "confirmationPage",
            event: "event",
            eventType: "ui"
        }).fire("signup");
        window.history.back();
    }
    const instanceUrl =
        "https://" +
        encodeURIComponent(String(onDemandUrl)) +
        getTopLevelDomain();

    const primaryProduct: string | undefined = getPrimaryProduct(products);
    // admin hub is using the confirmation page for polling should redirect to site not back to admin hub
    // https://atlassian.slack.com/archives/C05R8TWUXR9/p1740946058149969
    // if (admin) {
    //     return getAdminhubRedirectUrl(cloudId);
    // }

    if (typeof primaryProduct !== "string") {
        return instanceUrl;
    }

    if (primaryProduct === "opsgenie") {
        return getOpsgenieRedirectUrl(onDemandUrl, dataRegion);
    }

    if (primaryProduct === "statuspage") {
        return getStatuspageRedirectUrl(cloudId);
    }

    if (primaryProduct === "com.atlassian.bitbucket") {
        return getBitbucketRedirectUrl();
    }

    if (primaryProduct === "confluence.ondemand") {
        return getConfluenceJiraRedirectUrl(instanceUrl);
    }
    return instanceUrl;
};

export function createRedirectUrlForAutoRecommendedTemplate(
    customerSubdomain: string | undefined,
    templateId: string
) {
    const instanceUrl = `https://${encodeURIComponent(
        customerSubdomain ?? ""
    )}${getTopLevelDomain()}`;

    // navigate to welcome/software to load recommended template.
    const url = new URL("/welcome/software", instanceUrl);

    // This causes browser to retry for 30 seconds if site isn't ready
    url.searchParams.set("src", "signup");

    // this will prepopulate the create project screen with the given template.
    url.searchParams.set("templateId", templateId);

    return url.toString();
}

export function createRedirectUrlForAutoCreatedProject(
    customerSubdomain: string | undefined,
    path: string
) {
    const instanceUrl = `https://${encodeURIComponent(
        customerSubdomain ?? ""
    )}${getTopLevelDomain()}`;

    // navigate to welcome/software to load recommended template.
    const url = new URL(path, instanceUrl);

    return url.toString();
}

export const getPrimaryProduct = (products: readonly string[]) => {
    if (products.length > 0 && products[0] !== "") {
        return products[0];
    } else {
        return undefined;
    }
};

const getTopLevelDomain = (): string => {
    if (isProduction()) {
        return ".atlassian.net";
    } else {
        return ".jira-dev.com";
    }
};

const isValidOnDemandUrl = (siteName: string) => {
    const isUrl = siteName.includes(".");
    return !isUrl;
};

const getConfluenceJiraRedirectUrl = function (instanceUrl: string) {
    return instanceUrl + "/wiki";
};

const getBitbucketRedirectUrl = function () {
    if (!isProduction()) {
        return "https://integration.bb-inf.net/dashboard/overview";
    }

    return "https://bitbucket.org/dashboard/overview";
};

const getOpsgenieRedirectUrl = function (
    onDemandUrl: string | undefined,
    dataRegion: string | undefined
) {
    if (!isProduction()) {
        return `https://${onDemandUrl}.atlassian-app.opsgeni.us`;
    }
    if (dataRegion === "europe") {
        return `https://${onDemandUrl}.atlassian-app.eu.opsgenie.com`;
    }
    return `https://${onDemandUrl}.atlassian-app.opsgenie.com`;
};

const getStatuspageRedirectUrl = function (cloudId: string) {
    if (!isProduction()) {
        return "https://manage.statuspagestaging.com/cloud/" + cloudId;
    }

    return "https://manage.statuspage.io/cloud/" + cloudId;
};

// const getAdminhubRedirectUrl = (cloudId: string) => {
//     if (!isProduction()) {
//         return "https://admin.stg.atlassian.com/s/" + cloudId + "/setup";
//     }
//
//     return "https://admin.atlassian.com/s/" + cloudId + "/setup";
// };
